const SUBJECT_LABELS = {
  FRANCAIS: "langue française", DISSERTATION_FRANCAISE: "dissertation française",
  PHYSIQUE: "physique", PHYSIQUE_PRATIQUE: "physique pratique",
  INFORMATIQUE: "informatique", INFORMATIQUE_PRATIQUE: "informatique pratique",
  MATHEMATIQUES: "mathématiques", CHIMIE: "chimie", CHIMIE_PRATIQUE: "chimie pratique",
  PCT: "PCT", SVTEEHB: "SVTEEHB", SVTEEHB_PRATIQUE: "SVTEEHB pratique",
  HISTOIRE: "histoire", GEOGRAPHIE: "géographie", ECM: "ECM",
  PHILOSOPHIE: "philosophie", ETUDE_TEXTE: "étude de texte",
};

export const sanitizeWindowsFilename = (value, maxLength = 180) => {
  const withoutControlCharacters = Array.from(String(value || ""))
    .map((character) => character.charCodeAt(0) < 32 ? " " : character)
    .join("");
  const cleaned = withoutControlCharacters
    .replace(/[\\/:*?"<>|]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/[ .]+$/g, "");
  return (cleaned || "Epreuve").slice(0, maxLength).replace(/[ .]+$/g, "");
};

const periodLabel = (exam) => {
  const period = String(exam.period || "").trim();
  if (period) return /séquence/i.test(period) ? period : `Séquence ${period}`;
  const session = String(exam.session || "").trim();
  return session ? session.replaceAll("_", " ").toLowerCase() : "";
};

export const examDocumentFilename = (exam, kind = "pdf") => {
  const subjectCode = exam.subject || exam.matiere;
  const subject = SUBJECT_LABELS[subjectCode] || String(subjectCode || "épreuve").replaceAll("_", " ").toLowerCase();
  const parts = [`Epreuve de ${subject}`, periodLabel(exam), exam.establishment || ""].filter(Boolean);
  const prefix = kind === "correction_pdf" || kind === "correction" ? "Correction - " : "";
  const extension = kind === "docx" ? ".docx" : ".pdf";
  return `${sanitizeWindowsFilename(`${prefix}${parts.join(" - ")}`)}${extension}`;
};
